export default __webpack_public_path__ + "static/media/cockadoo-virgin-Rdio.54731ab3.jpg";